import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { IStore } from 'redux/store';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type EngineLogEPSCoverPageProps = PropsFromRedux & OwnProps;
function EngineLogEPSCoverPage(props: EngineLogEPSCoverPageProps) {
    const { vesselInfo, selectedDate } = props;
    const engineLogData = {
        firstPage: {
            mt: vesselInfo?.vesselName ?? '',
            callSign: vesselInfo?.callSign ?? '',
            officialNo: vesselInfo?.imoNumber ?? '',
            periodFrom:
                (selectedDate && moment(selectedDate).format('DD-MM-yyyy')) ??
                '',
            periodTo:
                (selectedDate && moment(selectedDate).format('DD-MM-yyyy')) ??
                '',
        },
    };

    const { firstPage } = engineLogData;
    const { mt, callSign, officialNo, periodFrom, periodTo } = firstPage;
    return (
        <>
            {/* First page */}
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="font-medium text-center text-xl my-24 mx-0">
                    <h2 className="uppercase text-2xl">ENGINE ROOM LOG BOOK</h2>
                </div>
                <div className="flex justify-center mt-8 mb-32">
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Vessel Name:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {mt}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Call Sign:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {callSign}
                            </p>
                        </div>

                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Official No:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {officialNo}
                            </p>
                        </div>
                        <div
                            className="flex justify-between items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center  mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period From :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {periodFrom}
                                </p>
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">To :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {periodTo}
                                </p>
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                English
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Second page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-8 mb-2 text-left print:pt-8">
                <h2 className="uppercase text-2xl font-semibold text-center print:pb-2">
                    INSTRUCTIONS FOR COMPLETION OF THE ENGINE ROOM LOGBOOK
                </h2>

                <ol className="list-decimal ml-4">
                    <li className="my-2 mx-0">
                        The Logbook shall be kept by the Chief Engineer and
                        written up by the engineer on watch according to the
                        under mentioned guidelines.
                    </li>
                    <li className="my-2 mx-0">
                        On the first page of the Logbook, the details of the
                        vessel, machinery and crew should be filled in.
                    </li>
                    <li className="my-2 mx-0">
                        The watch-keeping engineer shall sign his name and rank
                        in the appropriate column.
                    </li>
                    <li className="my-2 mx-0">
                        All entries shall be legible and to be made in ink only.
                    </li>
                    <li className="my-2 mx-0">
                        No columns to be left blank. Sections not relevant /
                        applicable, to be crossed out (-) appropriately.
                    </li>
                    <li className="my-2 mx-0">
                        At the Chief Engineer's discretion, blank column
                        headings to reflect the vessel's specific requirements.
                    </li>
                    <li className="my-2 mx-0">
                        The entry in each column should be the situation within
                        one hour before relief of watch, measured as usual.
                    </li>
                    <li className="my-2 mx-0">
                        Where automatic regulators of temperatures and pressures
                        are fitted, enter the standard adjusting temperature or
                        pressure and mark (*) above that part.
                    </li>
                    <li className="my-2 mx-0">
                        When a wrong entry has been made in the Logbook, a
                        single line shall be drawn across that part and the
                        correct entry with initials of the watch keeping
                        engineer shall be made near that entry. No cuts,
                        erasures or "white-outs" are acceptable.
                    </li>
                    <li className="my-2 mx-0">
                        For vessels operating UMS, the logbook shall be
                        completed thrice every 24hrs - around 0700, 1700 and
                        2200hrs.
                    </li>
                    <li className="my-2 mx-0">
                        The Chief Engineer shall sign the Logbook every day.
                    </li>
                    <li className="my-2 mx-0">
                        All Logbooks shall be retained on board for at least
                        three years.
                    </li>
                    <li className="my-2 mx-0">
                        The following entries should be made in the log book:
                        <ol className="list-alpha list-alpha-lower ml-4">
                            <li className="my-2 mx-0">
                                Special instructions issued by Master and/or
                                Chief Engineer.
                            </li>
                            <li className="my-2 mx-0">
                                All required particulars in their respective
                                columns.
                            </li>
                            <li className="my-2 mx-0">
                                Personal injuries, the time and details of
                                casualty.
                            </li>
                            <li className="my-2 mx-0">
                                Pollution incidents, time and details of same.
                            </li>
                            <li className="my-2 mx-0">
                                Any accident or troubles occurring to Engines,
                                Boilers or Auxiliaries - the time and details of
                                same.
                            </li>
                            <li className="my-2 mx-0">
                                Brief details of activities carried out due to
                                statutory requirements.
                            </li>
                            <li className="my-2 mx-0">
                                Brief details of the inspection and work carried
                                out, with respect to the CSM items handled by
                                the C/E.
                            </li>
                            <li className="my-2 mx-0">
                                Where applicable starting and stopping times of
                                Boilers, Auxiliary Engines, Cargo and Ballast
                                Pump, turbines, FWG and Steering motors in use.
                            </li>
                            <li className="my-2 mx-0">
                                Synchronisation of Clocks, testing of
                                communication and maneuvering system, steering
                                gear, standby equipment and related alarms prior
                                every arrival and departure port.
                            </li>
                            <li className="my-2 mx-0">
                                Standby, COP, EOP and FWE times for the Main
                                Engines, along with the relevant bunker
                                quantities at those times.
                            </li>
                            <li className="my-2 mx-0 print:pt-4">
                                Confirmation prior departure that an inspection
                                has been carried out, and all machinery spaces
                                have been secured and are ready for a sea
                                voyage.
                            </li>
                            <li className="my-2 mx-0">
                                Time of commencement and completion of receipt
                                of FO, LO, FW Bunkers, with total quantities
                                received.
                            </li>
                            <li className="my-2 mx-0">
                                Where applicable testing of Cargo and Ballast
                                pump/turbine alarms and trips prior every
                                discharge operation as applicable.
                            </li>
                            <li className="my-2 mx-0">
                                Trying out of the Lifeboat Engines. Emergency
                                Generator, Emergency Air Compressor, Emergency
                                Lighting, Emergency Fire pump, Emergency
                                Steering, Emergency Engine side maneuvering.
                            </li>
                            <li className="my-2 mx-0">
                                The start and stop timings for the running of
                                the OWS and the Waste oil incinerator,
                                consistent with entries in the Oil Record Book.
                            </li>
                            <li className="my-2 mx-0">
                                Commencement and completion of diving-operations
                                alongside vessel.
                            </li>
                            <li className="my-2 mx-0">
                                Details of Machinery/Equipment worked on or
                                isolated and personnel involved, related to the
                                issuance of Work Permits.
                            </li>

                            <li className="my-2 mx-0">
                                Removal of a lock out tag/device by the C/E
                                because the nominated Officer is no longer
                                onboard.
                            </li>
                            <li className="my-2 mx-0">
                                Any additional information that would assist in
                                watch keeping duties or be required for record
                                keeping purposes.
                            </li>
                            <li className="my-2 mx-0">
                                Dates and times of entering the ECA, together
                                with details of the start and end time of the
                                change-over, the ship's position, the fuel oil
                                tanks used and their contents should be
                                recorded.
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>
        </>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    const dateRange = inspectorSelectors.getDateRange(inspectorStore);

    return {
        vesselInfo,
        dateRange,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(EngineLogEPSCoverPage);
